const CellType = {
    CHECKBOX: 'CHECKBOX',
    NUMBER:  'NUMBER',
    DATE:'DATE',
    DATEONLY: 'DATEONLY',
    BOOLEAN: 'BOOLEAN',
    STRING: 'STRING',
    BOOLCONNECTED: 'BOOLCONNECTED',
    BOOLSTATUS: 'BOOLSTATUS',
    BOOLALARM: 'BOOLALARM',
    EDITABLE_NUMBER: 'EDITABLE_NUMBER',
    ACTIONS: 'ACTIONS',
    IMG: 'IMG',
    PRODUCT_NAME: 'NAME_PRODUCT',
    PRODUCT_SUM: 'SUM_PRODUCT',
    PRISE_WITH_DISCOUNT: 'PRISE_WITH_DISCOUNT',
    ORDERSUM: 'ORDERSUM',
    FINSTOCK: 'FINSTOCK',
    STRING_WITH_CURRENCY: 'NUMBER_WITH_CURRENCY',
    IS_INSTOCK_MORE_THAN_NUM: 'IS_INSTOCK_MORE_THAN_NUM',
    PACK_QTY: 'PACK_QTY',
    MIN_QTY: 'MIN_QTY',
}

export default CellType;
